import { useTranslation } from "react-i18next";

export function useTranslateConstants() {
  const { t } = useTranslation();

  const STEPS = {
    TAG_SELECTION: 1,
    SUMMARY: 2,
    CONFIRMATION: 3,
    SUCCESS: 4,
  };

  const STEP_LABELS = {
    SEARCH_TAG: t("searchTag"),
    SUMMARY: t("summary"),
    CONFIRMATION: t("confirmation"),
  };

  const TEXTS = {
    LOADING_TAGS: t("loadingTags"),
    CHOOSE_TAG: t("chooseTag"),
    TOTAL_RESULTS: t("totalResults"),
    LOADING: t("loading"),
    SUCCESS_MESSAGE: t("successMessage"),
    NEXT: t("next"),
    PRINT: t("print"),
    CANCEL: t("cancel"),
    CLOSE: t("close"),
  };

  return {
    STEPS,
    STEP_LABELS,
    TEXTS,
  };
}
